/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState, useEffect, cloneElement } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Constants
import { CHAIN_TYPE_SIMPLIFIED_OPTIONS } from 'common/constants/formOptions'
import { BLOCKCHAIN_SYMBOL_MONO_SVGS } from 'common/constants/blockchainMonoSvgs'

// Store
import { actions } from 'core/store'

// Styled Elements
import {
  TransferFormWrapper,
  FormInputGroupItem,
  FormGroupWrapper,
  FormWrapper,
  FormLabel,
  AssetContainer,
} from './AmountTransferForm.elements'

// Views
import { TextField, SimpleSelect } from 'views/components'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function AmountTransferForm(props) {
  // Destructure
  const { formData, setFormData, address } = props

  // Store
  const { addressChains } = address

  // Internal State
  const [availableChains, setAvailableChains] = useState()

  // functions
  function handleAvailableChains() {
    const providers = { ...addressChains?.financial }
    let allChains = {}
    Object.keys(providers).forEach((item) => {
      if (item === 'FDBDM') {
        allChains = { ...allChains, ...providers[item] }
      }
    })
    setAvailableChains(allChains)
  }

  const handleTransactionChange = (value) => {
    // Handle amount validation
    if (value.amount !== undefined) {
      // Allow empty string for clearing the field
      if (value.amount === '') {
        // Don't return early, allow empty string to be set
      } else {
        const numericAmount = parseFloat(value.amount)
        if (numericAmount < 0 || Number.isNaN(numericAmount)) {
          // Don't update if negative or invalid (but allow 0)
          return
        }
        // Convert to positive number if it's a valid positive value
        value.amount = Math.abs(numericAmount)
      }
    }

    setFormData({ ...formData, transfer: { ...formData.transfer, ...value } })
  }
  const handleAssetChange = (value) => {
    setFormData({ ...formData, transfer: { ...formData.transfer, ...value } })
  }

  // useEffect
  useEffect(() => {
    handleAvailableChains()
  }, [addressChains])

  return (
    <TransferFormWrapper>
      <FormWrapper>
        <FormGroupWrapper>
          <FormLabel>Please enter transfer amount</FormLabel>
          <FormInputGroupItem>
            <TextField
              placeholder="Amount e.g. 1.5"
              type="number"
              min="0"
              step="0.1"
              value={formData?.transfer?.amount || ''}
              onChange={(e) => {
                const inputValue = e.target.value

                // Allow empty string for clearing the field
                if (inputValue === '') {
                  handleTransactionChange({ amount: '' })
                  return
                }

                // Convert to number and check if positive
                const numericValue = parseFloat(inputValue)
                if (!Number.isNaN(numericValue) && numericValue >= 0) {
                  handleTransactionChange({ amount: numericValue })
                }
              }}
              onKeyDown={(e) => {
                // Prevent typing negative sign
                if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                  e.preventDefault()
                }
              }}
            />
            <AssetContainer>
              {BLOCKCHAIN_SYMBOL_MONO_SVGS[formData?.transfer?.asset_code || CHAIN_TYPE_SIMPLIFIED_OPTIONS[0].label] &&
                cloneElement(
                  BLOCKCHAIN_SYMBOL_MONO_SVGS[formData?.transfer?.asset_code || CHAIN_TYPE_SIMPLIFIED_OPTIONS[0].label]
                )}
              {availableChains && (
                <SimpleSelect
                  id="addressSearchOptionsChain"
                  placeholder="Chain"
                  options={Object.keys(availableChains).map((item) => ({
                    value: availableChains[item]?.symbol,
                    label: availableChains[item]?.symbol,
                  }))}
                  value={formData?.transfer?.asset_code || addressChains?.[Object.keys(addressChains)[0]]?.symbol}
                  onChange={(value) => {
                    handleAssetChange({ asset_code: value, dti: availableChains[value]?.dti })
                  }}
                />
              )}
            </AssetContainer>
          </FormInputGroupItem>

          <FormLabel>Please enter transaction hash (Optional)</FormLabel>
          <FormInputGroupItem id="txhashinput">
            <TextField
              placeholder="transaction hash"
              value={formData?.transfer?.tx_hash}
              onChange={(e) => {
                setFormData({ ...formData, transfer: { ...formData.transfer, tx_hash: e.target.value } })
              }}
            />
          </FormInputGroupItem>
        </FormGroupWrapper>
      </FormWrapper>
    </TransferFormWrapper>
  )
}

// Default Props
AmountTransferForm.defaultProps = {
  formData: {},
  setFormData: () => {},
  actions: {},
  form: {},
}

// Proptypes Validation
AmountTransferForm.propTypes = {
  formData: PropTypes.shape({
    transfer: PropTypes.shape({
      tx_hash: PropTypes.string,
      amount: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf(['']), // Only allow empty string
      ]),
      asset_code: PropTypes.string,
      protocol_code: PropTypes.string,
    }),
  }),
  actions: PropTypes.shape({
    setIsVaspDrawerOpen: PropTypes.func,
  }),
  form: PropTypes.shape({
    createdVasp: PropTypes.shape({}),
  }),
  setFormData: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(AmountTransferForm)
